// extracted by mini-css-extract-plugin
module.exports = {"item":"CourseSummaryTable-module--item--1p93c"};